import { useState } from "react";
import { Button } from "@boundary/components/button";
import { ChevronDown, ChevronUp } from "lucide-react";
import { formatRubles } from "@shared/utils/number/formatRubles";
import { getInfoByService } from "@domain/enums/local/getInfoByService";
import { useCollapsible } from "@boundary/_hooks/useCollapsible";
import { PriceDisplay } from "@boundary/components/PriceDisplay";
import type { ServiceType } from "@domain/enums/machine.enums";
import styles from "./cartSummary.module.scss";

interface ServiceSummary {
  id: string;
  type: ServiceType;
  price: number;
}

interface CartSummaryProps {
  totalPrice: number;
  originalPrice?: number;
  discount?: number;
  services: ServiceSummary[];
}

export function CartSummary({ totalPrice, originalPrice, discount, services }: CartSummaryProps) {
  const [expanded, setExpanded] = useState(false);
  const ref = useCollapsible(expanded);

  if (totalPrice === 0) return null;

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <span className={styles.label}>Сумма</span>
        <PriceDisplay
          totalPrice={totalPrice}
          originalPrice={originalPrice}
          discount={discount}
          className={styles.priceWrapper}
        />
        {services.length > 0 && (
          <Button
            size="icon"
            variant="secondary"
            onClick={() => setExpanded((v) => !v)}
          >
            {!expanded ? <ChevronDown /> : <ChevronUp />}
          </Button>
        )}
      </div>
      <div ref={ref} className={styles.content}>
        {services.map((service) => (
          <div className={styles.serviceItem} key={service.id}>
            <span className={styles.serviceLabel}>
              {getInfoByService(service.type).title}
            </span>
            <p>{formatRubles(service.price)}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

